export function mapObject(obj, mapping = {}) {
  const mappedObject = {}

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      const mappedKey = mapping[key]
      if (mappedKey) mappedObject[mappedKey] = obj[key]
    }
  }

  return mappedObject
}
